import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import TextField from '@material-ui/core/TextField';
import { withStyles, createStyles } from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';

// FIXME skip global styles
const styles = ({
  custom: {
    palette: { colorSuccess, colorDanger },
  },
}) =>
  createStyles({
    fieldIcon: {
      right: 16,
      position: 'absolute',
      top: 12,
      zIndex: 10,
    },
    input: {
      '&$valid': {
        border: `1px solid ${colorSuccess}`,
      },
      '&$invalid': {
        border: `1px solid ${colorDanger}`,
      },
    },
    invalid: {
      color: colorDanger,
    },
    valid: {
      color: colorSuccess,
    },
    wrapper: {
      display: 'inline-block',
      float: 'left',
      position: 'relative',
    },
  });

class CodeField extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    const { input, type } = this.props;
    const {
      target: { value },
    } = event;

    input.onChange(type === 'number' ? parseInt(value, 10) : value);
  }

  renderFieldIcon(value, valid) {
    const { classes } = this.props;

    if (!value || value.length !== 6) return;

    if (valid) {
      return <CheckCircleIcon className={classnames(classes.fieldIcon, classes.valid)} />;
    }

    return <ErrorIcon className={classnames(classes.fieldIcon, classes.invalid)} />;
  }

  render() {
    const {
      autoFocus,
      classes,
      input: { value, onBlur },
      meta: { error, touched },
      valid,
      ...other
    } = this.props;

    return (
      <div className={classes.wrapper}>
        <TextField
          error={touched && !!error}
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            className: classnames(classes.input, {
              [classes.valid]: value.length === 6 && valid,
              [classes.invalid]: value.length === 6 && !valid,
            }),
            autoFocus,
            disableUnderline: true,
            inputProps: {
              className: classnames({
                [classes.valid]: value.length === 6 && valid,
                [classes.invalid]: value.length === 6 && !valid,
              }),
              maxLength: 6,
            },
          }}
          onBlur={onBlur}
          onChange={this.onChange}
          value={value}
          {...other}
        />
        {this.renderFieldIcon(value, valid)}
      </div>
    );
  }
}

CodeField.propTypes = {
  autoFocus: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  type: PropTypes.string,
  valid: PropTypes.bool,
};

CodeField.defaultProps = {
  autoFocus: false,
  valid: false,
};

export default withStyles(styles)(CodeField);
